import React, { Component } from "react";
import Chart from "react-apexcharts";

class LineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
          
          // colors: ["#f88477","#9e63f0"],
          series: [{
            name:'Received',
            data: []
          }],
      options: {
        colors: ["#1d75ee","#9e63f0"],
        chart: {
          type: 'bar',
          height: 350,
        },
        stroke: {
          curve: 'smooth',
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
            // formatter: undefined,
        },
          y: {
            show: true,
            formatter: function(value){
              return '₹' + Number(value).toLocaleString('en-IN');
            },
        }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (value) {
            return '₹' + Number(value).toLocaleString('en-IN');
          }
        },
        xaxis: {
          categories: this.props.labels??[],
          
          labels: {
            formatter: function (value) {
              return value //'$' + Number(value).toLocaleString('en-IN');
            },
            style: {
              fontSize: '12px',
              fontWeight: 800,

            }
          }
          },
        
        yaxis: {
          labels: {
            formatter: function (value) {
              return '₹' + Number(value).toLocaleString('en-IN');
            },
            style: {
              fontSize: '12px',
              fontWeight: 800,

            }
          }
        
        },
        
        grid: {
          show: true,
          strokeDashArray: 7,
          xaxis: {
            lines: { 
              show: false  //or just here to disable only y axis
             },
            // labels: {
            //   formatter: function (value) {
            //     return 'aaa' //'$' + Number(value).toLocaleString('en-IN');
            //   }
            // }
           },
          yaxis: {
            lines: { 
              show: true,  //or just here to disable only y axis
             },
            //  labels: {
            //   formatter: function (value) {
            //     return 'ddssss' //$' + Number(value).toLocaleString('en-IN');
            //   }
            // }
             
           },
        },
      },
    
    
    };
    
    }

    componentDidUpdate(prevProps) {
      if (prevProps.labels !== this.props.labels) {
        console.log(prevProps.labels);
        console.log(this.props.labels);

        this.setState({
          options: {
            ...this.state.options,
            xaxis: {
              ...this.state.options.xaxis,
              categories: this.props.labels,
              labels: {
                style: {
                  fontSize: '10px',
                  fontWeight: 500,
                  color:'red'
                }
              }
            }
          }
          
        });

      //  console.log(this.state);
      }
    }
  render() {
    return (
      <>
      
              <Chart
                options={this.state.options}
                series={this.props.series}
                labels={this.props.labels}
                type="line"
                height="500"

                />
      </>
    );
  }
}
 
export default LineChart;